import React, { FC, useEffect } from 'react';
import classNames from 'classnames';
import { RouteComponentProps } from 'react-router';
import styles from './assets/incentive-edit-screen.module.scss';
import Loader from 'src/components/Loader';
import RoleLayout from 'src/components/layout/RoleLayout';
import { IIncentive } from 'src/types/incentive';

export interface StateProps {
    incentive: IIncentive | null;
    inProgress: boolean;
}

export interface DispatchProps {
    getData: (id: string | number) => void;
}

interface RouteParams {
    id: string;
}

export interface OwnProps extends RouteComponentProps<RouteParams> {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const IncentiveEditScreen: FC<Props> = (props: Props) => {
    const {
        incentive,
        inProgress,
        match: {
            params: { id },
        },
        getData,
    } = props;

    useEffect(() => {
        if (!incentive || incentive.id !== id) {
            getData(id);
        }
        // eslint-disable-next-line
    }, [getData, id]);

    if (!incentive || inProgress) {
        return <Loader />;
    }

    return (
        <RoleLayout>
            <div>
                <h2>INCENTIVES {`>`} EDIT INCENTIVE</h2>
            </div>
            <div className={classNames(styles.editWrap)}>{/*  <Form initialValues={{ ...incentive }} />*/}</div>
        </RoleLayout>
    );
};
export default IncentiveEditScreen;
